import { useRef } from 'react';
import { PAYMENT_SCENES_SECTION } from '../../../data/site';
import { usePaymentSceneMarquee } from '../../../hooks/usePaymentSceneMarquee';

function PaymentSceneCard({
  category,
  tag,
  description,
  image,
  alt,
}: (typeof PAYMENT_SCENES_SECTION.scenes)[number]) {
  return (
    <article className="testimonial-item payment-scene">
      <div className="testimonial-image-wrap">
        <img src={image} loading="lazy" alt={alt} className="fit-cover" />
        <div className="testimonial-image-cover" aria-hidden="true" />
      </div>
      <div className="testimonial-content-wrap">
        <div className="testimonial-author-wrap payment-scene__pill">
          <div className="payment-scene__pill-copy">
            <div className="paragraph-02">{category}</div>
            <div className="tag">{tag}</div>
          </div>
        </div>
        <div className="testimonial-details-wrap">
          <p className="text-style-h5 testimonial-details">{description}</p>
        </div>
      </div>
    </article>
  );
}

function PaymentSceneTrack({ duplicate = false }: { duplicate?: boolean }) {
  return (
    <div
      className="payment-scene-marquee__track testimonial-list"
      data-marquee-track=""
      aria-hidden={duplicate || undefined}
    >
      {PAYMENT_SCENES_SECTION.scenes.map((scene) => (
        <PaymentSceneCard
          key={duplicate ? `${scene.category}-dup` : scene.category}
          {...scene}
        />
      ))}
    </div>
  );
}

export function TestimonialSection() {
  const marqueeRef = useRef<HTMLDivElement>(null);
  usePaymentSceneMarquee(marqueeRef);

  return (
    <section className="testimonial payment-scenes">
      <div className="container">
        <div className="section-header-wrap">
          <div className="section-header-left">
            <div className="heading-wrap">
              <h2>{PAYMENT_SCENES_SECTION.title}</h2>
            </div>
            <div className="subtitle-wrap left-small">
              <div className="paragraph-02 text-dark-grey-two">{PAYMENT_SCENES_SECTION.subtitle}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="payment-scene-wrap">
        <div ref={marqueeRef} className="payment-scene-marquee">
          <PaymentSceneTrack />
          <PaymentSceneTrack duplicate />
        </div>
      </div>
    </section>
  );
}
